import './details/details';
import './details/details-cart';
import './details/details-accommodation';
//import './details/details-fix';
import './details/details-package';
import './details/details-package-with-flight-api';
import './details/details-travel';

$(() => {

    // ALERT BOOKING START
    window.alertBookingTimeout = {};

    window.setAlertBooking = ($target) => {
        const $unit = $target.closest('.unit');
        const unitId = $unit.attr('data-unitid');
        const $alertBooking = $unit.find('.alert-booking');

        $alertBooking.addClass('active');
        const alertTimeout = setTimeout(() => {
            $alertBooking.removeClass('active');
        }, 4000);

        window.alertBookingTimeout[unitId] = alertTimeout;
    }

    $('.alert-booking [data-close]').on('click', e => {
        const $target = $(e.currentTarget);
        const $unit = $target.closest('.unit');
        const unitId = $unit.attr('data-unitid');
        const $alertBooking = $target.closest('.alert-booking');

        $alertBooking.removeClass('active');

        if (window.alertBookingTimeout[unitId]) {
            clearTimeout(window.alertBookingTimeout[unitId]);
            window.alertBookingTimeout[unitId] = 0;
        }
    });
    // ALERT BOOKING END

    // READ MORE START
    const $readMoreContent = $('#description .read-more-content, #price-includes .read-more-content');

    if ($readMoreContent.length) {
        const contentheight = $readMoreContent.height();
        contentheight > 140 && contentheight > 200 && $readMoreContent.addClass('active') && $readMoreContent.siblings('.read-more-open').removeClass('d-none');
    }

    $('.read-more').each((i, elem) => {
        let $content = $(elem).find('.read-more-content');
        let $close = $(elem).find('.read-more-close');
        let $open = $(elem).find('.read-more-open');

        $($open).on('click', function(e) {
            $($content).addClass('no-before expand');
            $(e.currentTarget).addClass('d-none');
            $($close).removeClass('d-none');
        })

        $($close).on('click', function(e) {
            $($content).removeClass('expand');
            $(e.currentTarget).addClass('d-none');
            $($open).removeClass('d-none');

            $('html, body').stop().animate({
                scrollTop: $(elem).offset().top
            }, 0);
            setTimeout(function() {
                $($content).removeClass('no-before');
            }, 500);

        });
    });
    // READ MORE END


    $('.see-on-map').on('click', e => {
        const $target = $(e.currentTarget);
 
        let modalTitle = $target.parent().find('.title-for-modal').text();
        $('#meetPointMap').find('.modal-title').text(modalTitle);
 
        let latLng = $target.attr('data-latlng');
        let $mpMap = $('#meetPointMap').find('.metting-point-map');
        let mapLink = $mpMap.attr('data-src').split('q=')[0];
        mapLink += 'q=' + latLng;
        $mpMap.attr('src', mapLink);
        $mpMap.attr('data-src', mapLink);
 
    });

    // UNIT LINK OPEN MODAL AND TAB
    $('[data-bs-toggle="modal"][data-bs-tab]').on('click', e => {
        const $target = $(e.currentTarget);
        const unitId = $target.attr('data-unitid');
        const $tab = $('#unitModal-' + unitId).find('[id=' + $target.attr('data-bs-tab') + ']');
        $tab.tab('show');
    });

    if(! +$('#booking').attr('data-dynamicpackage')) {
        const programURL = $('[data-programurl]').length ? $('[data-programurl]').attr('data-programurl') : null;
        if(programURL) {
            $.get(programURL).done(response => {
                response = JSON.parse(response);
                if (response.status) {
                    const $travelProgramModal = $('#travelProgramModal');
                    $travelProgramModal.find('.modal-body').html(response.html);
                    $travelProgramModal.find('.btn-print').attr('data-params', $(response.html).find('[data-print]:first').attr('data-print'));

                    $('.travel-program-link').removeClass('d-none');
                } else {
                    $('.travel-program-link').addClass('d-none');
                }
            }).fail(e => {
                $('.travel-program-link').addClass('d-none');
            });
        }
    }

    $('.btn-print-travel-program').on('click', e => {
        const $modalContent = $('#travelProgramModal').find('.modal-body');
        const modalContent = $modalContent[0];
        const $head = $('head');
        const head = $head[0];

        let htmlToPrint = head.outerHTML + '<style>@page { size:  auto; margin-top: 60px; margin-bottom: 60px; }</style>' + '<body>' + modalContent.outerHTML + '</body>';
        let windowToPrint = window.open("");

        windowToPrint.document.write(htmlToPrint);
        setTimeout(() => {
            windowToPrint.print();
            windowToPrint.close();
        }, 500);
    });

});